export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40cee61192478e26f4de245a3e7bfb8d6d2eadb8ec&name=addToFolderEventAction!'